import { ColorInfo } from "components/icons/ColorInfo";
import { InvoiceForm } from "components/InvoiceForm/InvoiceForm";
import { InvoiceInfo } from "components/InvoiceInfo/InvoiceInfo";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useQuery } from "hooks/useQuery";
import { ComponentProps, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useGetEntityInvoiceQuery } from "store/apis/invoices";

export const FormikListener = ({
  values,
  callback,
}: {
  values: Record<string, any>;
  callback: (v: Record<string, any>) => void;
}) => {
  const stringValues = JSON.stringify(values);

  useEffect(() => {
    callback(values);
  }, [stringValues]);

  return null;
};

export const AddInvoice = ({
  onChange,
  readOnly = false,
}: {
  onChange: ComponentProps<typeof InvoiceForm>["onChange"];
  readOnly?: boolean;
}) => {
  const { invoiceId } = useParams<{
    invoiceId: string;
  }>();
  const query = useQuery();
  const group = useCurrentGroupContext();
  const editFlow = query.get("editflow");
  const entityId = useCurrentEntityId();

  const { data: invoice } = useGetEntityInvoiceQuery(
    {
      groupId: group?.uuid!,
      entityId: entityId!,
      invoiceId,
    },
    { skip: !group?.uuid || !entityId, refetchOnMountOrArgChange: true }
  );

  const isInvoiceSent =
    invoice && (invoice.status === "DUE" || invoice.status === "OVERDUE");
  const isSentInvoiceEditFlow = isInvoiceSent && Boolean(editFlow);

  if (!invoice) {
    return null;
  }

  if (readOnly && invoice.status !== "DRAFT") {
    return <InvoiceInfo />;
  }

  return (
    <>
      {isSentInvoiceEditFlow && (
        <div className="t-rounded-lg t-bg-purple-0 t-border t-border-solid t-border-purple-30 t-p-2.5 t-flex t-items-center t-gap-2 t-text-purple t-mb-4">
          <ColorInfo />
          <div className="t-text-body-sm t-text-text-30">
            You are editing an active invoice
          </div>
        </div>
      )}

      {invoice.status === "DRAFT" || isSentInvoiceEditFlow ? (
        <InvoiceForm onChange={onChange} groupId={group?.uuid!} />
      ) : (
        <InvoiceInfo />
      )}
    </>
  );
};
